import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import { AppShell } from "@/components/layout/AppShell";
import { ProtectedRoute } from "@/components/common/ProtectedRoute";
import SetupPage from "@/pages/SetupPage";
import LoginPage from "@/pages/LoginPage";
import SelectPage from "@/pages/SelectPage";
import ControlRoomPage from "@/pages/DashboardPage";
import AddCameraPage from "@/pages/AddCameraPage";
import CameraSettingsPage from "@/pages/CameraSettingsPage";
import DeviceDetailPage from "@/pages/DeviceDetailPage";
import EnrollPage from "@/pages/EnrollPage";
import AgentPage from "@/pages/AgentPage";
import AuditPage from "@/pages/AuditPage";
import SettingsPage from "@/pages/SettingsPage";
import "@/App.css";

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/setup" element={<SetupPage />} />
          <Route path="/login" element={<LoginPage />} />

          {/* Legacy browser-device flow. Kept available only from Settings > Advanced. */}
          <Route path="/device-camera" element={<ProtectedRoute><SelectPage /></ProtectedRoute>} />
          <Route path="/select" element={<Navigate to="/device-camera" replace />} />
          <Route path="/enroll" element={<ProtectedRoute><EnrollPage /></ProtectedRoute>} />
          <Route path="/agent" element={<ProtectedRoute><AgentPage /></ProtectedRoute>} />

          {/* CAM V2 main experience */}
          <Route element={<ProtectedRoute><AppShell /></ProtectedRoute>}>
            <Route path="/" element={<Navigate to="/cameras" replace />} />
            <Route path="/cameras" element={<ControlRoomPage />} />
            <Route path="/cameras/new" element={<AddCameraPage />} />
            <Route path="/cameras/:id" element={<CameraSettingsPage />} />

            {/* Backward-compatible aliases */}
            <Route path="/control-room" element={<Navigate to="/cameras" replace />} />
            <Route path="/dashboard" element={<Navigate to="/cameras" replace />} />
            <Route path="/live" element={<Navigate to="/cameras" replace />} />
            <Route path="/devices" element={<Navigate to="/cameras" replace />} />

            <Route path="/devices/:id" element={<DeviceDetailPage />} />
            <Route path="/audit" element={<AuditPage />} />
            <Route path="/settings" element={<SettingsPage />} />
          </Route>

          <Route path="*" element={<Navigate to="/cameras" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
